import { RiyalImgBLK } from "../../../components/common/RiyalImg";
import { handlePDFClick } from "../../../utilities/handleFunctions/HandlePDFOpen"

function UserReqDetials({ orderId, numberOfForms, language, orderDescription, subServices, orderStatus, serviceName, offerFile, customerFile, offerPrice, t }) {

    return (
        <div id={`user-order-details-${new Intl.NumberFormat("en-IN", { minimumIntegerDigits: 3 }).format(orderId,)}`}
            className="modal fade bg-transparent"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="orderDetailsLabel"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="orderDetailsLabel">{t("OfferDetails")}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <h6 className="mt-3">{serviceName}</h6>
                        <table className="table text-start ">
                            <tbody>
                                {numberOfForms > 1 && <tr>
                                    <td>{t("ItemsCount")}</td>
                                    <td>{numberOfForms}</td>
                                </tr>}
                                {<tr>
                                    <td>{t("language")}</td>
                                    {language === "arabic" ?
                                        <td>{t("Arabic")}</td>
                                        : language === "english" ?
                                            <td>{t("English")}</td>
                                            : <td>{t("ArabicEnglish")}</td>
                                    }
                                </tr>}
                                {subServices && <tr>
                                    <td>{t("Requested Services")}</td>
                                    <td>{subServices}</td>
                                </tr>}
                                {offerPrice && <tr>
                                    <td>{t("Service Cost")}</td>
                                    <td>{offerPrice}<RiyalImgBLK /></td>
                                </tr>}
                                <tr>
                                    <td>{t("OrderStatus")}</td>
                                    <td>{orderStatus}</td>
                                </tr>
                                <tr>
                                    <td>{t("Attachments")}</td>
                                    <td >
                                        {customerFile &&
                                            <button className="btn-masar-sm btn-light-beige"
                                                value={customerFile}
                                                onClick={handlePDFClick}>
                                                {t("MyFiles")}</button>
                                        }</td>
                                </tr>
                                <tr>
                                    <td>{t("theOffer")}</td>
                                    <td >
                                        {offerFile ?
                                            <button className="btn-masar-sm btn-dark-orange"
                                                value={offerFile}
                                                onClick={handlePDFClick}>
                                                {t("Open")}</button>
                                            :
                                            <button className="btn-masar-sm btn-light-beige"
                                                onClick={handlePDFClick} disabled>
                                                {t("InProgress")}</button>
                                        }</td>
                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <h6 className="mt-4">{t("Details")}</h6>
                            <p>{orderDescription}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { UserReqDetials };